import { faker } from '@faker-js/faker'

import { UserTreatment } from '../../contracts/treatment'
import { asBuilder } from '../asBuilder'

export const getUserTreatment = asBuilder<UserTreatment>((): UserTreatment => {
  return {
    id: faker.number.int(),
    name: faker.string.uuid(),
    label: faker.string.uuid(),
    tagMeta: {
      name: faker.string.uuid(),
      nameKr: faker.string.uuid(),
    },
  }
})
